<template>
  <div class="side-menu-container">
    <v-card class="pa-4 pt-7 side-menu" flat :disabled="loading">
      <div>
        <h2 class="ml-4 mb-6 text-left">Sections</h2>
        <v-timeline truncate-line="both" side="end">
          <v-timeline-item
            v-for="item in items"
            size="x-small"
            :dot-color="isCompleted(item) ? 'primaryButton' : 'white'"
            :fill-dot="isCompleted(item)"
            class="py-2 px-6 text-left"
          >
            <template v-slot:icon>
              <v-progress-circular
                v-if="item === items[nextItemSetIndex] && loading"
                indeterminate
                :color="isCompleted(item) ? 'white' : 'primaryButton'"
                :size="12"
                :width="2"
              ></v-progress-circular>
              <div class="mb-1" v-else>
                <v-icon
                  v-if="isCompleted(item)"
                  :icon="'mdi-check'"
                  :size="'x-small'"
                ></v-icon>
              </div>
            </template>
            <div class="d-flex justify-space-between flex-grow-1">
              <v-row>
                <div
                  class="side-menu__item"
                  :class="
                    items[activeItem] === item ? 'side-menu__item--active' : ''
                  "
                  @click="setNextSectionIndex(item.sectionTitle)"
                >
                  {{ item.sectionTitle }}
                </div>
              </v-row>
            </div>
          </v-timeline-item>
        </v-timeline>
      </div>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import type { QuestionnaireSideMenuItem } from "@/models/questionnaireSideMenuItem";
import { AnswerStatus } from "@/models/enum/answerStatus";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";
import { ref } from "vue";

defineProps<{
  items: QuestionnaireSideMenuItem[];
  activeItem: number;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: "new-section", newSectionIndex: number): void;
}>();

const selectedQuestionnaireStore = useSelectedQuestionnaire();
const nextItemSetIndex = ref(0);

function isCompleted(item: QuestionnaireSideMenuItem) {
  return item.isSectionCompleted === AnswerStatus.Completed;
}

function setNextSectionIndex(nextSectionTitle: string) {
  nextItemSetIndex.value = selectedQuestionnaireStore.itemSets.findIndex(
    (item) => item.title === nextSectionTitle
  );
  emit("new-section", nextItemSetIndex.value);
}
</script>

<style scoped lang="scss">
.side-menu-container {
  position: sticky;
  top: 70px;
}
.side-menu {
  width: 300px;
  border-radius: 12px;
}

.side-menu__item {
  width: 200px;
  border-radius: 7px;
  padding: 6px;
  &:hover {
    cursor: pointer;
    background-color: var(--light-tangerine-4);
  }
}

.side-menu__item--active {
  background-color: var(--light-tangerine-3);
}
</style>
